const breadImages = [
  {
    file: 'breads/bread-slice.webp',
    title: 'Bread slice',
    categoryKey: 'wholegrain',
    categories: ['wholegrain'],
    ingredients: 'Wholegrain flour, water, sourdough starter, and sea salt.',
    description: 'A hearty homemade loaf with a deep flavour, soft crumb, and natural wholegrain texture.',
  },
  {
    file: 'breads/dinkel-bread1.webp',
    title: 'Dinkel bread',
    categoryKey: 'dinkel',
    categories: ['wholegrain', 'dinkel'],
    ingredients: 'Dinkel flour, water, sourdough starter, and sea salt.',
    description: 'A classic spelt loaf with a delicate crumb and a warm, nutty finish.',
  },
  {
    file: 'breads/dinkel-bread2.webp',
    title: 'Dinkel loaf',
    categoryKey: 'dinkel',
    categories: ['dinkel'],
    ingredients: 'Dinkel flour, water, sourdough starter, and sea salt.',
    description: 'Slow-fermented spelt bread with a light crust and a generous, tender centre.',
  },
  {
    file: 'breads/dinkel-kerne.webp',
    title: 'Dinkel seed bread',
    categoryKey: 'mixes',
    categories: ['mixes', 'dinkel'],
    ingredients: 'Dinkel flour, mixed seeds, water, sourdough starter, and sea salt.',
    description: 'A generous seeded loaf made for sharing, with a satisfying bite and toasted flavour.',
  },
  {
    file: 'breads/dinkel-toast.webp',
    title: 'Dinkel toast',
    categoryKey: 'dinkel',
    categories: ['white', 'dinkel'],
    ingredients: 'Dinkel flour, water, sourdough starter, milk, and sea salt.',
    description: 'A soft spelt loaf that is ideal for breakfast, sandwiches, and relaxed brunch tables.',
  },
  {
    file: 'breads/dinkel3.webp',
    title: 'Dinkel-Roggen bread',
    categoryKey: 'dinkelRye',
    categories: ['dinkelRye'],
    ingredients: 'Dinkel flour, rye flour, water, sourdough starter, and sea salt.',
    description: 'A balanced spelt and rye bread with a fuller flavour and a beautifully crisp crust.',
  },
  {
    file: 'breads/dinkel5.webp',
    title: 'Dinkel bread, golden crust',
    categoryKey: 'dinkelRye',
    categories: ['wholegrain', 'dinkelRye'],
    ingredients: 'Dinkel flour, wholegrain flour, water, sourdough starter, and sea salt.',
    description: 'A rustic loaf baked for a golden crust, rich aroma, and satisfying everyday slices.',
  },
  {
    file: 'breads/kozunak3.webp',
    title: 'Kozunak bread',
    categoryKey: 'kozunak',
    categories: ['kozunak'],
    ingredients: 'Wheat flour, eggs, milk, butter, sugar, yeast, and citrus zest.',
    description: 'A soft, gently sweet braided pastry made for celebrations and generous coffee tables.',
  },
  {
    file: 'breads/kozunak4.webp',
    title: 'Kozunak loaf',
    categoryKey: 'kozunak',
    categories: ['kozunak'],
    ingredients: 'Wheat flour, eggs, milk, butter, sugar, yeast, and citrus zest.',
    description: 'A golden homemade kozunak with a tender crumb and a lightly sweet finish.',
  },
  {
    file: 'breads/testo.webp',
    title: 'White sourdough bread',
    categoryKey: 'goldenGrain',
    categories: ['white', 'goldenGrain', 'mixes'],
    ingredients: 'White flour, water, live sourdough starter, and sea salt.',
    description: 'White sourdough bread with a bright crumb and the golden crust of a slow bake.',
  },
  {
    file: 'breads/dinkel-pure.jpg',
    title: 'Pure spelt loaf',
    categoryKey: 'dinkel',
    categories: ['dinkel', 'wholegrain'],
    ingredients: 'Dinkel flour, water, sourdough starter, and sea salt.',
    description: 'A simple spelt loaf with a soft crumb and a gently nutty flavour.',
  },
  {
    file: 'breads/dinkel-fruits2.jpg',
    title: 'Spelt fruit bread',
    categoryKey: 'mixes',
    categories: ['mixes', 'dinkel'],
    ingredients: 'Dinkel flour, dried fruit, water, sourdough starter, and sea salt.',
    description: 'A naturally sweet spelt loaf with fruit throughout and a fragrant crust.',
  },
  {
    file: 'breads/dinkel-pumpkin.jpg',
    title: 'Spelt pumpkin bread',
    categoryKey: 'goldenGrain',
    categories: ['goldenGrain', 'dinkel', 'mixes'],
    ingredients: 'Dinkel flour, pumpkin, water, sourdough starter, and sea salt.',
    description: 'A golden seasonal loaf with a tender crumb and roasted pumpkin flavour.',
  },
  {
    file: 'breads/bread-ss.jpg',
    title: 'Golden crust loaf',
    categoryKey: 'goldenGrain',
    categories: ['goldenGrain', 'white'],
    ingredients: 'Wheat flour, water, sourdough starter, and sea salt.',
    description: 'A fresh loaf with a deep golden crust and a light, open crumb.',
  },
  {
    file: 'breads/dinkel-br.jpg',
    title: 'Spelt rye bread',
    categoryKey: 'dinkelRye',
    categories: ['dinkelRye', 'wholegrain'],
    ingredients: 'Dinkel flour, rye flour, water, sourdough starter, and sea salt.',
    description: 'A hearty spelt and rye loaf with a rich aroma and a satisfying texture.',
  },
  {
    file: 'breads/dinkel-toast-bread.jpg',
    title: 'Homemade spelt toast',
    categoryKey: 'white',
    categories: ['white', 'dinkel'],
    ingredients: 'Dinkel flour, water, milk, sourdough starter, and sea salt.',
    description: 'A soft homemade toast loaf for breakfast, sandwiches, and brunch.',
  },
  {
    file: 'breads/kozunak5.jpg',
    title: 'Celebration kozunak',
    categoryKey: 'kozunak',
    categories: ['kozunak'],
    ingredients: 'Wheat flour, eggs, milk, butter, sugar, yeast, and citrus zest.',
    description: 'A soft braided sweet bread with a golden finish, made for festive tables.',
  },
];

export default breadImages;
